export enum DetailViewContentElementType {
  PageTitle = 1,
  Actions = 2,
  PageSubtitle = 3,
  Subheading = 4,
  TextArea = 5,
  Action = 6,
  FormList = 7,
  FileProperty = 8,
  Heading = 9,

  Grid = 101,
  Stack = 102,

  ModelProperty = 201,
  RelatedObject = 202,
  DocumentLink = 203,
  ModelHistory = 204,
  RelationSection = 205,


  Header = 301,

  Divider = 401,

  TabBreak = 402
}

export const ContainableElements = [
  DetailViewContentElementType.Grid,
  DetailViewContentElementType.Stack,
  DetailViewContentElementType.RelationSection,
];

export const UnRelationSectionable = [
  DetailViewContentElementType.RelationSection,
  DetailViewContentElementType.ModelHistory,
  DetailViewContentElementType.TabBreak,
  DetailViewContentElementType.FormList,
]